<!--
 * @Author: MouXiaowei
 * @Date: 2022-08-25 14:24:02
 * @Description: 转盘抽奖
-->
<template>
  <div class="lottery-box" :style="{backgroundImage:bgUrl, backgroundColor:bgColor}">
    <div class="lottery-big-wheel-box">
        <big-wheel
        width="317px"
        height="317px"
        ref="bigWheel"
        :prizeList="prizeList"
        @over="over">
            <template v-slot:item="{ item }">
                <img class="lottery-prize-img" :src="item.img">
            </template>
        </big-wheel>

        <!-- 开始按钮 -->
        <img v-if="lotteryCount <= 0" class="lottery-btn-go" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_go_disenable.png" />
        <img v-else class="lottery-btn-go" @click="go" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_go_enable.png" />
    </div>
    <div class="lottery-bottom">
        <img class="lottery-bottom-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_bottom.png"/>
    </div>

    <div class="prize-box">
        <div class="prize-header">
            <div class="prize-point"></div>
            <div class="prize-point"></div>
            <div class="prize-point"></div>
            <div class="prize-title">活动说明</div>
            <div class="prize-point"></div>
            <div class="prize-point"></div>
            <div class="prize-point"></div>
        </div>
        <div class="prize-toast">{{remark}}</div>
        <div v-if="prizeInfoList.length > 0" class="prize-list-header">
            <div class="prize-point"></div>
            <div class="prize-point"></div>
            <div class="prize-point"></div>
            <div class="prize-title">奖项设置</div>
            <div class="prize-point"></div>
            <div class="prize-point"></div>
            <div class="prize-point"></div>
        </div>
        <div class="prize-list" v-for="(item, index) in prizeInfoList" :key="index">
            <div class="prize-list-item-green" :class="{'prize-list-item-yellow' : index % 2 == 0}">
                <div class="prize-list-item-title">{{item.prizeName}}</div>
                <div class="prize-list-item-desc">{{item.prizeDesc}}</div>
            </div>
        </div>
        <div class="empty-box"></div>
    </div>
    <van-popup class="carbon-dialog-box" v-model="isShowRewardDialog" :safe-area-inset-bottom="true" :close-on-click-overlay="false">
        <div v-if="resInfo != null" class="carbon-dialog">
            <div class="carbon-dialog-img">
                <div class="carbon-dialog-img-prize">{{resInfo.prizeName}}</div>
            </div>
            <div class="carbon-dialog-content">
                <div class="carbon-dialog-title">恭喜您获得</div>
                <p class="carbon-dialog-value">{{resInfo.prizeDesc}}</p>
                <div class="carbon-dialog-btn" @click="handleAppJumpWith(resInfo)">{{resInfo.prizeType == 1 ? '优惠券可在卡券包查看' : '碳能量限今日收取'}}</div>
            </div>
            <img class="carbon-dialog-close" src="~@/assets/images/super/sign_dialog_close.png"  @click="handlePopupClose"/>
        </div>
    </van-popup>
  </div>
</template>
<script>
import { setStore } from '@/utils/index'
import { getLotteryInfo, getLotteryRes } from '@/api/active'
import BigWheel from '@/components/lottery/BigWheel'
import { Toast, Popup } from 'vant'
export default {
  name: 'lotteryActive',
  components: {
    [Popup.name]: Popup,
    BigWheel
  },
  data () {
    return {
      prizeList: [
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_prize_1.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_prize_2.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_prize_3.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_prize_4.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_prize_5.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_prize_6.png'
        }
      ],
      prizeBgColors: ['#FFF7C8', '#FFF7C8'],
      borderColor: '#F9614B',
      turnsNumber: 3,
      turnsTime: 3,
      valve: false, // 防止连续点击
      activityId: null, // 抽奖活动id
      bgColor: null, // 背景色
      bgUrl: null, // 背景图
      remark: null, // 活动描述
      prizeInfoList: [], // 奖项列表
      lotteryCount: null, // 今日可用抽奖次数
      isShowRewardDialog: false, // 中奖弹框
      resInfo: null // 中奖信息
    }
  },
  mounted () {
    const token = this.$route.query.accessToken
    if (token) {
      setStore('token', token)
    }
    this.activityId = this.$route.query.activityId
    this.getLotteryInfo()
  },
  methods: {
    // 关闭弹框
    handlePopupClose () {
      this.isShowRewardDialog = false
    },
    // 弹框按钮跳转
    handleAppJumpWith (appVO) {
      this.isShowRewardDialog = false
      // eslint-disable-next-line no-undef
      dsBridge.call('callNativeViewLifeCycle', {
        ...appVO,
        refreshFlag: 1
      })
    },
    // 获取中奖活动详情信息
    getLotteryInfo () {
      getLotteryInfo(this.activityId).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              this.bgColor = res.data.result.backgroundColor
              this.bgUrl = 'url(' + res.data.result.iconUrl + ')'
              this.prizeInfoList = res.data.result.prizeInfoList
              this.lotteryCount = res.data.result.lotteryCount
              this.remark = res.data.result.remark
            }
          }
        }
      })
    },
    // 抽奖
    getLotteryRes () {
      getLotteryRes(this.activityId).then((res) => {
        this.lotteryCount -= 1
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              this.resInfo = res.data.result
              this.isShowRewardDialog = true
            }
          }
        }
      }).catch(() => {

      })
    },
    // 开始转动
    go () {
      if (this.valve) {
        return
      }
      if (this.lotteryCount <= 0) {
        Toast({
          message: '今日抽奖次数已用完！'
        })
        return
      }
      this.valve = true
      // 模拟随机数，这里可以请求后台获取中将信息
      const index = Math.floor(Math.random() * this.prizeList.length)
      this.winningIndex = index

      // 转动转盘
      this.$refs.bigWheel.rotate(index)
    },
    // 转盘转完事件
    over (prizeInfo) {
      this.valve = false
      this.getLotteryRes()
    }
  }
}
</script>
<style lang="scss">
.lottery-box {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  .lottery-big-wheel-box {
    margin-top: (360vw / 7.5);
    background-image: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_wheel_bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    padding: .76rem;
    .lottery-prize-img {
      position: absolute;
      top: 40px;
      left: 50%;
      transform: translateX(-50%);
      width: 50px;
      height: 48px;
    }
    .lottery-btn-go {
      position: absolute;
      top: (550vw / 7.5);
      left: 50%;
      transform: translateX(-50%);
      width: 85px;
    }
  }
  .lottery-bottom {
    &-img {
        width: 256px;
    }
  }

  .prize-box {
    width: (690vw / 7.5);
    border-radius: 5px 5px 5px 5px;
    background: rgba(255,255,255,1);
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .prize-point {
        margin-left: 5.5px;
        width: 4.5px;
        height: 4.5px;
        background: rgba(89,175,73,1);
        border-radius: 2.25px;
    }
    .prize-title {
        font-weight: Bold;
        font-size: 17px;
        padding-left: 30px;
        padding-right: 30px;
        color: #3B4F26;
        line-height: 30px;
    }
    .prize-header {
        padding-top: 18px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 20px;
    }

    .prize-toast {
        margin-top: 10px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
        font-size: 14px;
        color: #3B4F26;
        padding-left: 30px;
        padding-right: 30px;
    }

    .prize-list-header {
        padding: 18px 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 30px;
    }

    .prize-list {
        display: flex;
        flex-direction: column;
        align-items: center;

        .prize-list-item-green {
            margin-bottom: 10px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 230px;
            height: 18px;
            border-radius: 5px 5px 5px 5px;
            background: rgba(236,247,223,1);
        }
        .prize-list-item-yellow {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 230px;
            height: 18px;
            border-radius: 5px 5px 5px 5px;
            background: rgba(255,247,205,1);
        }
        .prize-list-item-title {
            margin-left: 30px;
            width: 50px;
            font-weight: 400;
            line-height: 18px;
            font-size: 14px;
            color: #3B4F26;
            text-align: left;
        }
        .prize-list-item-desc {
            flex: 1;
            padding-left: 30px;
            text-align: left;
            font-weight: 400;
            line-height: 18px;
            font-size: 14px;
            color: #3B4F26;
        }
    }
  }
  .empty-box {
      height: 10px;
  }
}

.carbon-dialog-box {
    background-color: rgba($color: #fff, $alpha: 0);
}
.carbon-dialog {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .carbon-dialog-img {
        background-image: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_dialog_icon.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        width: 166px;
        height: 144px;
        z-index: 1;
        .carbon-dialog-img-prize {
            margin-top: 98px;
            line-height: 20px;
            font-weight: 400;
            font-size: 17px;
            text-align: center;
        }
    }

    .carbon-dialog-close {
        margin-top: 20px;
    }

    .carbon-dialog-content {
        margin-top: -30px;
        width: 250px;
        background-color: #fff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .carbon-dialog-title {
            margin-top: 40px;
            height: 21px;
            font-weight: 500;
            font-size: 16px;
            color: #333233;
        }
        .carbon-dialog-value {
            margin-top: 10px;
            height: 18px;
            font-weight: 400;
            font-size: 16px;
            color: #333233;
        }
        .carbon-dialog-btn {
            margin-top: 12px;
            margin-bottom: 20px;
            width: 160px;
            height: 36px;
            border-radius: 18px;
            background: rgba(249,97,75,1);
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
        }
    }
}

</style>
